var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTemplates = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53832 5.07775C2.53832 3.31897 3.44949 2.40861 5.18069 2.40861H10.6355V2.25379C10.6355 0.978047 9.99163 0.333984 8.72815 0.333984H2.24068C0.965052 0.333984 0.333313 0.978047 0.333313 2.25379V8.76873C0.333313 10.0507 0.965052 10.6885 2.24068 10.6885H2.53832V5.07775ZM5.27181 13.6673H11.7593C13.0288 13.6673 13.6666 13.0294 13.6666 11.7537V5.17065C13.6666 3.89491 13.0288 3.25084 11.7593 3.25084H5.27181C4.00226 3.25084 3.36444 3.89491 3.36444 5.17065V11.7537C3.36444 13.0294 4.00226 13.6673 5.27181 13.6673Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTemplates);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-templates.2b69be4961fda39b6c6b7a22d609bcfc.svg";